import { render } from "./SpreadsheetReviewModal.vue?vue&type=template&id=0c49a454&scoped=true&ts=true"
import script from "./SpreadsheetReviewModal.vue?vue&type=script&lang=ts"
export * from "./SpreadsheetReviewModal.vue?vue&type=script&lang=ts"

import "./SpreadsheetReviewModal.vue?vue&type=style&index=0&id=0c49a454&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c49a454"]])

export default __exports__